import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import HomeHero from "../components/HomeHero";
import FeatureGrid from "../components/FeatureGrid";
import LeaderboardPreview from "../components/LeaderboardPreview";
import LatestVideos from "../components/LatestVideos";
import FAQ from "../components/FAQ";
import { FAQ_ENABLED } from '../content/siteVisibility';
import Footer from "../components/Footer";
import AuthDialog from "../components/AuthDialog";
import { HomeOriginals } from '../components/originals/HomeOriginals';
import { WaysToEarnHeading } from '../components/WaysToEarnHeading';

const Home = () => {
  const location = useLocation();
  const [authOpen, setAuthOpen] = useState(false);
  const [authMode, setAuthMode] = useState("login");

  const openAuth = (mode) => {
    setAuthMode(mode);
    setAuthOpen(true);
  };

  // Scroll to hash target if present (e.g. /#features)
  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 100);
    }
  }, [location]);

  return (
    <div className="relative">
      <Sidebar onAuth={openAuth} />

      <div className="content-shift pt-16">
        <main>
          <HomeHero onAuth={openAuth} />
          <LeaderboardPreview />
          <section id="features" className="scroll-mt-24" aria-labelledby="home-features-title" data-testid="home-rewards-section">
            <WaysToEarnHeading />
            <HomeOriginals />
            <FeatureGrid />
          </section>
          <LatestVideos />
          {FAQ_ENABLED && <FAQ />}
        </main>

        <Footer />
      </div>

      <AuthDialog
        open={authOpen}
        onOpenChange={setAuthOpen}
        mode={authMode}
        setMode={setAuthMode}
      />
    </div>
  );
};

export default Home;
